const C = {
  name: "OneTwoThree",
  dimensions: { width: 40, height: 19 },
  content: `
    <svg fill="currentColor">
    <g clip-path="url(#clip0_12_4928)">
    <path d="M9 16.0029H6V3.00293C6 1.35293 4.65 0.00292969 3 0.00292969H1C0.45 0.00292969 0 0.45293 0 1.00293C0 1.55293 0.45 2.00293 1 2.00293H3C3.55 2.00293 4 2.45293 4 3.00293V16.0029H1C0.45 16.0029 0 16.4529 0 17.0029C0 17.5529 0.45 18.0029 1 18.0029H9C9.55 18.0029 10 17.5529 10 17.0029C10 16.4529 9.55 16.0029 9 16.0029Z" fill="#00112C"/>
    <path d="M22 0.00292969H16C15.45 0.00292969 15 0.45293 15 1.00293C15 1.55293 15.45 2.00293 16 2.00293H22C22.55 2.00293 23 2.45293 23 3.00293V7.00293C23 7.55293 22.55 8.00293 22 8.00293H18C16.35 8.00293 15 9.35293 15 11.0029V16.0029C15 17.1029 15.9 18.0029 17 18.0029H24C24.55 18.0029 25 17.5529 25 17.0029C25 16.4529 24.55 16.0029 24 16.0029H17V11.0029C17 10.4529 17.45 10.0029 18 10.0029H22C23.65 10.0029 25 8.65293 25 7.00293V3.00293C25 1.35293 23.65 0.00292969 22 0.00292969Z"/>
    <path d="M40 3.00293C40 1.35293 38.65 0.00292969 37 0.00292969H31C30.45 0.00292969 30 0.45293 30 1.00293C30 1.55293 30.45 2.00293 31 2.00293H37C37.55 2.00293 38 2.45293 38 3.00293V7.00293C38 7.55293 37.55 8.00293 37 8.00293H31C30.45 8.00293 30 8.45293 30 9.00293C30 9.55293 30.45 10.0029 31 10.0029H37C37.55 10.0029 38 10.4529 38 11.0029V15.0029C38 15.5529 37.55 16.0029 37 16.0029H31C30.45 16.0029 30 16.4529 30 17.0029C30 17.5529 30.45 18.0029 31 18.0029H37C38.65 18.0029 40 16.6529 40 15.0029V11.0029C40 10.2329 39.7 9.53293 39.22 9.00293C39.7 8.47293 40 7.77293 40 7.00293V3.00293Z" />
    </g>
    <defs>
    <clipPath id="clip0_12_4928">
    <rect width="40" height="18" fill="currentColor" transform="translate(0 0.00292969)"/>
    </clipPath>
    </defs>
    </svg>
  `
};
export {
  C as OneTwoThree
};
